// store/index.js
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import app from './modules/app'
import getters from './getters'

export default createStore({
  modules: {
    app
  },
  getters,
  plugins: [
    createPersistedState({
      key: 'kingdee-app-storage', // 存储的key名称
      paths: ['app'], // 只持久化app模块
      storage: window.localStorage,

      // 只保存需要的字段
      reducer: (state) => ({
        app: {
          token: state.app.token,
          userInfo: state.app.userInfo,
          menuList: state.app.menuList,
          logginIdentity: state.app.logginIdentity,
          lang: state.app.lang
          // 不保存临时状态如 siderType
        }
      }),

      beforeSave: (state) => {
        console.log('保存状态前:', state)
        return state
      },

      afterRestore: (context) => {
        console.log('状态恢复后:', context)
      }
    })
  ]
})
